require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 1023
// module chunks = 0